import { useContext } from "react";

import type { DispatchMembershipProductEvaluationCodeType } from "~/clientState/providers/generic/PrimeEventManager/types/PrimeEventEmitterType";
import PrimeEventEmitterContext from "../contexts";
import { EventEmitterCatalog } from "~/clientState/providers/generic/PrimeEventManager";

const useDispatchMembershipProductEvaluationCode =
  (): DispatchMembershipProductEvaluationCodeType => {
    const dispatchers = useContext(PrimeEventEmitterContext);
    return dispatchers.eventEmitterHook(
      EventEmitterCatalog.MEMBERSHIP_PRODUCT_EVALUATION_CODE_DISPATCHED,
    );
  };

export default useDispatchMembershipProductEvaluationCode;
